import { createSlice } from "@reduxjs/toolkit";

export const settingsSlice = createSlice({
    name:'settings',
    initialState:{
        loanProviderTypes:[],
        approvalTimes:[],
        ltvs:[],
        productTypes:[],
        productSchemes:[],
        productMotorTypes:[],
        productCategories:[],
        productUsages:[],
        vehicles: [],  
    },
    reducers:{
        update:(state,action)=>
        {
            return{
                agentVisibilityRules:action.payload.agentVisibilityRules,
                loanProviderTypes:action.payload.loanProviderTypes,
                approvalTimes:action.payload.approvalTimes,
                ltvs:action.payload.ltvs,
                loanProviderTypes:action.payload.loanProviderTypes,
                productSchemes:action.payload.productSchemes,
                productMotorTypes:action.payload.productMotorTypes,
                vehicles:action.payload.vehicles,
                categories:action.payload.categories,
                productUsages:action.payload.productUsages,
                collect_first_installment_options: action.payload.collect_first_installment_options
              }
        }
    }
})

export const {update} = settingsSlice.actions

export default settingsSlice.reducer